exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2KzlC9CNfxIGqJQwJFLS-G{white-space:nowrap}._2rxXWVq3YnwnfuY0Z5sTu7{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-justify-content:space-around;-ms-flex-pack:distribute;justify-content:space-around;width:100%}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"MarkHomeworkCourseView_header": "_2KzlC9CNfxIGqJQwJFLS-G",
	"MarkHomeworkCourseView_content": "_2rxXWVq3YnwnfuY0Z5sTu7"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.2/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/Homework/PaperBased/MarkHomeworkCourseView/style.postcss
// module id = 1693
// module chunks = 0